import styled from 'styled-components';
import {
  ScEmblaArrows,
  ScEmblaPagination,
} from '@/components/EmblaCarousel/components/styled';
import { device, hexToRGB } from '@/styles/helpers';

export const ScMissionLevels = styled.div`
  position: relative;
  z-index: 0;
  max-width: 768px;
  width: 100%;
  margin: 0 auto 24px;
  padding: 14px 32px 22px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;

  min-height: 391px;
  @media (${device.mobile}) {
    padding: 16px;
    padding-bottom: 26px;

    ${ScEmblaPagination} {
      margin-top: 16px;
    }
  }

  ${ScEmblaArrows} {
    & .embla__arrow {
      top: 40%;
      transform: translateY(-40%);
    }
  }

  .bgFrame {
    position: absolute;
    inset: 0;
    z-index: 0;
    overflow: hidden;
    background: rgba(16, 16, 16, 0.9);
    backdrop-filter: blur(6.5px);
    pointer-events: none;
    clip-path: polygon(
      1.8% 0%,
      62.05% 0%,
      63.32% 0.87%,
      84.89% 0.87%,
      86.15% 0%,
      98.2% 0%,
      100% 3.47%,
      100% 96.53%,
      98.2% 100%,
      88.17% 100%,
      86.9% 99.13%,
      13.1% 99.13%,
      11.83% 100%,
      1.8% 100%,
      0% 96.53%,
      0% 49.78%,
      0.45% 48.24%,
      0.45% 16.9%,
      0% 15.1%,
      0% 3.47%
    );
  }

  > *:not(.bgFrame) {
    position: relative;
    z-index: 1;
  }

  .levelsTitle {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 0.44px;
    color: ${({ theme }) => theme.whiteColor};
    text-align: center;
    margin-bottom: 8px;
  }

  .guestMeter {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-bottom: 4px;
  }

  .guestMeter .divider {
    width: 100%;
    max-width: 704px;
    height: 7px;
    background: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
    clip-path: polygon(
      0 0,
      16.16% 0,
      17.62% 85.7%,
      85.72% 85.7%,
      87.18% 0,
      100% 0,
      100% 1px,
      87.18% 1px,
      85.72% 100%,
      17.62% 100%,
      16.16% 1px,
      0 1px
    );
  }

  .guestTitle {
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    margin-top: 12px;
    letter-spacing: 0.14px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.whiteColor};
  }

  .guestCaption {
    font-size: 12px;
    line-height: 14px;
    color: #c1c2c5;
  }
`;
